import { render, staticRenderFns } from "./event-split.vue?vue&type=template&id=a870b62c&scoped=true"
import script from "./event-split.ts?vue&type=script&lang=js&external"
export * from "./event-split.ts?vue&type=script&lang=js&external"
import style0 from "./event-split.less?vue&type=style&index=0&id=a870b62c&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a870b62c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a870b62c')) {
      api.createRecord('a870b62c', component.options)
    } else {
      api.reload('a870b62c', component.options)
    }
    module.hot.accept("./event-split.vue?vue&type=template&id=a870b62c&scoped=true", function () {
      api.rerender('a870b62c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/event-split/event-split.vue"
export default component.exports